import { Component, OnInit } from '@angular/core';
import { NSSService } from 'app/shared/services/app.service';
import { Agency } from 'app/shared/interfaces/agency';
import { Stationtype } from 'app/shared/interfaces/stationtype';
import { IMultiSelectSettings, IMultiSelectTexts } from '../../../../node_modules/angular-2-dropdown-multiselect';
import { Region } from 'app/shared/interfaces/region';
import { SettingsService } from 'app/settings/settings.service';
import { ConfigService } from 'app/config.service';
import { Config } from 'protractor';
import { Regressiontype } from 'app/shared/interfaces/regressiontype';
import { Variabletype } from 'app/shared/interfaces/variabletype';
import { Regulationstatus } from 'app/shared/interfaces/regulationstatus';
import { Statisticgroup } from 'app/shared/interfaces/statisticgroup';
import { HttpParams } from '@angular/common/http';
import { LoaderService } from 'app/shared/services/loader.service';
import { Station } from 'app/shared/interfaces/station';

@Component({
  selector: 'gs-sidebar',
  templateUrl: './gs-sidebar.component.html',
  styleUrls: ['./gs-sidebar.component.scss']
})
export class GsSidebarComponent implements OnInit {
  private configSettings: Config;
  public stationTypes: Array<Stationtype>;
  public regressionTypes: Array<Regressiontype>;
  public statisticGroups: Array<Statisticgroup>;
  public variableTypes: Array<Variabletype>;
  public regulationStatuses: Array<Regulationstatus>;
  public regions: Array<Region>;
  public agencies: Array<Agency>;
  // Dropdown menu default text
  public myMSTexts: IMultiSelectTexts;
  public myRTSettings: IMultiSelectSettings;
  public params = new HttpParams();
  public selectedRegions = [];
  public selectedStationTypes = [];
  public selectedAgencies = [];
  public selectedStatisticGroups = [];
  public selectedRegressionTypes = [];
  public selectedVariableTypes = [];
  public selectedRegulationStatuses = [];
  public keyword = "";
  public timeout: any = null;
  public loadCount = 0;
  public requeryFilter: boolean;

  constructor(private _nssService: NSSService, public _settingsservice: SettingsService, private _configService: ConfigService, private _loaderService: LoaderService) {
    this.configSettings = this._configService.getConfiguration();
  }

  ngOnInit() {
    this._nssService.requeryGSFilter.subscribe((bool:boolean)=>{
      this.requeryFilter = bool;
      if (this.requeryFilter = true){
        this.onSearch();
      }
    });
    this._nssService.selectedPageNumber.subscribe((page: string) => {
      if (page == " ") {
        page = '1';
      }
      this.params = this.params.set('page', page);
      this._nssService.searchStations(this.params);
    });
    this._nssService.selectedPerPage.subscribe((perPage: string) => {
      if (perPage == " ") {
        perPage = '50';
      }
      this.params = this.params.set('pageCount', perPage);
      this._nssService.searchStations(this.params);
    });
    this._nssService.getStationTypes();
    this._nssService.stationTypes.subscribe((st: Array<Stationtype>) => {
      this.stationTypes = st;
    });
    this._nssService.getAgencies();
    this._nssService.agencies.subscribe((ag: Array<Agency>) => {
      this.agencies = ag;
    });
    this._settingsservice.getEntities(this.configSettings.gageStatsBaseURL + this.configSettings.regionURL).subscribe((regions: Array<Region>) => {
      this.regions = regions;
    });
    this._settingsservice.getEntities(this.configSettings.gageStatsBaseURL + this.configSettings.statisticGrpURL).subscribe((sg: Array<Statisticgroup>) => {
      this.statisticGroups = sg;
    });
    this._settingsservice.getEntities(this.configSettings.gageStatsBaseURL + this.configSettings.variablesURL).subscribe((vt: Array<Variabletype>) => {
      this.variableTypes = vt;
    });
    this._settingsservice.getEntities(this.configSettings.gageStatsBaseURL + this.configSettings.regTypeURL).subscribe((rt: Array<Regressiontype>) => {
      this.regressionTypes = rt;
    });
    // subscribe to stations subject, which is set in the service's searchStations() function
    this._nssService.Stations.subscribe((s: Array<Station>) => {
      this._loaderService.hideFullPageLoad();
    });

    this.regulationStatuses = [
      {id: true, name: "Regulated"},
      {id: false, name: "Not Regulated"}
    ];

    // trigger initial stations search
    this._nssService.searchStations(this.params);

    this.myRTSettings = {
      pullRight: false,
      enableSearch: true,
      checkedStyle: 'glyphicon', // 'checkboxes',
      buttonClasses: 'btn btn-default',
      selectionLimit: 0,
      closeOnSelect: false,
      showCheckAll: true,
      showUncheckAll: true,
      dynamicTitleMaxItems: 2,
      maxHeight: '300px'
    };

    this.myMSTexts = {
      checkAll: 'Check all',
      uncheckAll: 'Uncheck all',
      checked: 'checked',
      checkedPlural: 'checked',
      defaultTitle: 'Select'
    };

  }  // end OnInit()

  // search stations
  public onSearch() {
    this.loadCount = this.loadCount + 1;
    if (this.loadCount > 7) {  //resolves issue with multiple filter calls on load
      this._loaderService.showFullPageLoad();
      //set up params
      this.params = this.params.set('page', '1');
      this.params = this.params.set('regions', this.selectedRegions.toString()); 
      this.params = this.params.set('agencies', this.selectedAgencies.toString()); 
      this.params = this.params.set('stationtypes', this.selectedStationTypes.toString()); 
      this.params = this.params.set('statisticgroups', this.selectedStatisticGroups.toString()); 
      this.params = this.params.set('regressiontypes', this.selectedRegressionTypes.toString()); 
      this.params = this.params.set('variableTypes', this.selectedVariableTypes.toString()); 
      this.params = this.params.set('isRegulated', this.selectedRegulationStatuses.toString()); 
      this.params = this.params.set('filterText', this.keyword.toString()); 
      // make request based on params
      this.requeryFilter = false;
      this._nssService.setSelectedFilterParams(this.params);
      this._nssService.searchStations(this.params);
    }
  }

  //Waits for user to quit typing
  public onKeySearch(event: any) {
    clearTimeout(this.timeout);
    var $this = this;
    this.timeout = setTimeout(function () {
      if (event.keyCode != 13) {
        $this.onSearch();
      }
    }, 750);
  }

  //Clear filters
  public clearGagestatsFilters() {
    //Reset search parameters to bring gage table back to default view
    this.params = new HttpParams();
    this.selectedRegions = [];
    this.selectedAgencies = [];
    this.selectedStationTypes = []; 
    this.selectedVariableTypes = [];
    this.selectedRegulationStatuses = [];
    this.selectedRegressionTypes = [];
    this.selectedStatisticGroups = [];
    this.keyword = "";
    //Refresh the search without any filters selected
    this._nssService.setSelectedFilterParams(this.params);
    this._nssService.searchStations(this.params);
  }

}

